export enum MediaAccessType {
  CARD = 'CARD',
  PHONE = 'PHONE'
}

export enum MediaAccessStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELED = 'CANCELED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  LOCKED = 'LOCKED'
}

export enum MediaAccessVirtualStatus {
  LEGACY = 'LEGACY',
  VIRTUAL = 'VIRTUAL',
  PHYSICAL = 'PHYSICAL'
}

export enum MediaAccessDeliveryStatus {
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED',
  IN_TRANSIT = 'IN_TRANSIT',
  LINKED = 'LINKED'
}


export class MediaAccess {
  id: number;
  type: MediaAccessType;
  maskedValue: string;
  status: MediaAccessStatus;
  physicalCardRequested: boolean;
  activationDate: Date;
  virtualStatus: MediaAccessVirtualStatus;

  constructor(object: any = null) {
    if (object != null) {
      Object.assign(this, object);
      this.type = typeof object.type == 'number' ? object.type : MediaAccessType[object.type as string];
      this.status = typeof object.status == 'number' ? object.status : MediaAccessStatus[object.status as string];
    }
  }
}
